import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftComponents/SoftButton";
import { useAuth0 } from "@auth0/auth0-react";

import userAPI from "services/api/user";
import Swal from "sweetalert2";
import { useSoftUIController } from "hooks/context";

const handlePasswordReset = async (email) => {
    // 1. Show a loading state immediately (Good for high-latency connections)
    Swal.fire({
        title: '<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:28px">Sending Request...</div>',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    try {
        const response = await fetch(`https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
                client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
                email: email,
                connection: 'Username-Password-Authentication'
            })
        });

        if (response.ok) {
            // 2. Success Alert: Auto-closes in 2 seconds
            Swal.fire({
                icon: 'success',
                title: '<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:28px">Email Sent!</div>',
                html: '<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:20px">You should receive an email within the next 5 minutes. Please check your inbox for reset instructions.</div>',
                showConfirmButton: true,
            });
        } else {
            throw new Error('Failed to send');
        }
    } catch (error) {
        // 3. Error Alert
        Swal.fire({
            icon: 'error',
            title: '<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:28px">Request Failed</div>',
            html: '<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:20px">We could not reach the identity server. Please try again.</div>',
            confirmButtonColor: '#344767', // Matches Soft UI Dark palette
        });
    }
};

function ChangePassword({ user }) {
    userAPI.loadToken(useAuth0());

    const [controller] = useSoftUIController();
    const { appearance, deviceLayout } = controller;

    return (
        <SoftBox p={1} sx={{
            height: deviceLayout == 'mobile' ? 'unset' : 'calc(100svh - 12.1rem - 16px)',
            overflowY: 'auto',
            width: deviceLayout == 'mobile' ? 'unset' : 'calc(100svw - 260px - 64px)',
        }}>
            <SoftBox px={{ xxs: 2, lg: 3 }} pb={{ xxs: 2, lg: 3 }} pt={3} sx={{ borderRadius: "1rem" /*, backgroundColor: "#f9f9f9" */ }}>
                <SoftBox mb={3} textAlign="left" display="flex" flexDirection="column">
                    <SoftTypography variant="subtitle3" fontWeight="medium" color="text" display={deviceLayout == 'mobile' ? 'block' : 'none'}>Account Settings</SoftTypography>
                    <SoftTypography variant="h4" fontWeight="bold" color={appearance}>Password Manager</SoftTypography>
                    <SoftTypography variant="button" fontWeight="regular" color="text">Securely reset your password</SoftTypography>
                </SoftBox>
                <SoftButton variant="gradient" color="primary" onClick={() => handlePasswordReset(user.user.email)}>
                    Send Password Reset Email
                </SoftButton>
            </SoftBox>
        </SoftBox>
    );
}


ChangePassword.propTypes = {
    user: PropTypes.object
}

export default ChangePassword;